import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import {
    ADMIN_SESSION_KEY,
    AdminVideoGroup,
    AdminVideoRow,
    buildAdminVideoGroups,
    isAdminPassword,
    saveVideoFile,
    videoFileName,
    VideoTranslations,
} from 'src/app/admin/video-catalog';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
})
export class AdminComponent implements OnInit {
    unlocked = false;
    password = '';
    passwordError = '';
    loading = false;
    loadError = '';
    groups: AdminVideoGroup[] = [];
    downloadingUrl: string = null;
    downloadError = '';

    constructor(private http: HttpClient) {}

    ngOnInit() {
        this.unlocked = sessionStorage.getItem(ADMIN_SESSION_KEY) === '1';
        if (this.unlocked) {
            this.loadVideos();
        }
    }

    submitPassword() {
        if (!isAdminPassword(this.password)) {
            this.passwordError = 'Incorrect password';
            return;
        }
        this.passwordError = '';
        this.password = '';
        sessionStorage.setItem(ADMIN_SESSION_KEY, '1');
        this.unlocked = true;
        this.loadVideos();
    }

    videoCount(): number {
        return this.groups.reduce((total, group) => total + group.videos.length, 0);
    }

    loadVideos() {
        this.loading = true;
        this.loadError = '';
        forkJoin({
            en: this.http.get<Record<string, string>>('assets/i18n/en.json'),
            es: this.http.get<Record<string, string>>('assets/i18n/es.json'),
            cn: this.http.get<Record<string, string>>('assets/i18n/cn.json'),
        }).subscribe(
            (translations: VideoTranslations) => {
                this.groups = buildAdminVideoGroups(translations);
                this.loading = false;
            },
            () => {
                this.loading = false;
                this.loadError = 'Could not load the video list.';
            }
        );
    }

    async download(video: AdminVideoRow) {
        this.downloadingUrl = video.url;
        this.downloadError = '';
        try {
            await saveVideoFile(video.url, videoFileName(video));
        } catch (error) {
            this.downloadError = `Could not download ${video.topic}.`;
        } finally {
            if (this.downloadingUrl === video.url) {
                this.downloadingUrl = null;
            }
        }
    }
}
